import { offerService } from 'services/offer.service'
import { courseService } from 'services/course.service'
import { paramsHook } from 'external/deep-diff'
import { isUUID, partition } from 'external/lodash'

const hooks =  [
  {paths: paramsHook('pageName'), resolves: [fetchOffers]},
  {paths: paramsHook('pageName', 'offerId'), resolves: [fetchOfferData]},
  {paths: paramsHook('pageName', 'courseId'), resolves: [fetchCourseDetails]},
]

export {hooks as default}

export async function fetchOffers({update, state}) {
    const {offers: {initialized}} = state
    if (initialized) return
    update({offers: {$startLoading: {}}})
    const offers = await offerService.getActiveOffers()
    update({offers: {$updateLoadableList: offers.data.data}}) 
}


export async function fetchOfferData ({update, state}) {

    const {offersData, props: {navigation, params: {offerId}}} = state

    if (! (navigation.offer.active || navigation.offerSubjects.active || navigation.offerCourses.active)) return
    if (!isUUID(offerId)) return
    if (offersData[offerId]) return

    const subjectsResponse = await offerService.getOffersSubjectsById(offerId)
    const subjects = subjectsResponse.data.data.filter(({active}) => active)
    const [basic, elective] = partition(subjects, ({id}) => id !== 'C7')

    const coursesResponse = await courseService.getCoursesForOffer(offerId)
    const courses = coursesResponse.data.data.filter(({active}) => active)

    const data = {basic, elective, courses}
    
    update({ offersData: {[offerId]: {$set: data}}})

}

export async function fetchCourseDetails({update, state}) {

    const {courseDetails, props: {params: {courseId}}} = state
    if (!courseId) return
    if (!courseDetails[courseId]) {
        const response = await courseService.getCoursesDetails(courseId)
        update({courseDetails: {[courseId]: {$set: response.data.data}}})
    }
}